import { render, staticRenderFns } from "./DeclareResultAmendment.vue?vue&type=template&id=00080e8f&scoped=true"
import script from "./DeclareResultAmendment.vue?vue&type=script&lang=js"
export * from "./DeclareResultAmendment.vue?vue&type=script&lang=js"
import style0 from "./DeclareResultAmendment.vue?vue&type=style&index=0&id=00080e8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00080e8f",
  null
  
)

export default component.exports